var React = require('react');

function IconProfile (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M16 7a3 3 0 1 1-3 3 3.009 3.009 0 0 1 3-3m0 15c4.05 0 8.7 1.935 9 3H7c.345-1.08 4.965-3 9-3m0-18a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm0 15c-4.005 0-12 2.01-12 6v3h24v-3c0-3.99-7.995-6-12-6z","transform":"translate(-4 -4)"}));
}

IconProfile.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconProfile;

IconProfile.default = IconProfile;
